import script from "./ArticleSpecialTypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleSpecialTypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./ArticleSpecialTypeFilter.vue?vue&type=style&index=0&id=336a8a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336a8a7a"]])

export default __exports__